<template>
  <div class="school-post-edit">
    <el-form ref="form" :model="form" label-position="top" :rules="rules" v-loading="loading">
      <el-row>
        <el-col :span="8">
          <el-form-item  label="请输入文章标题" prop="title">
<!--            <el-input  size="mini" v-model="form.title" type="text" :rows="1" :maxlength=50 autosize placeholder="请输入标题(建议50字以内)" show-word-limit clearable />-->
            <stu-input-size-limit v-model="form.title" class="axj-post-school-create" max-length="50" placeholder="请输入标题(建议50字以内)"></stu-input-size-limit>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="content" style="margin-top: 0px">
        <d2-quill v-model="form.content" @text-change="textChangeHandler" @selection-change="selectionChangeHandler" @editor-change="editorChangeHandler" />
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="15" >
          <el-form-item style="margin-top: -10px" label="附件（非必须添加附件）">
            <el-row>
              <el-col :span="18">
                <love-element-upload
                  :list-type="uploadOption.listType"
                  :drag="uploadOption.drag"
                  :allow-type="uploadOption.allowType"
                  :allow-size="uploadOption.allowSize"
                  :disabled="uploadOption.disabled"
                  :limit="uploadOption.limit"
                  :multiple="uploadOption.multiple"
                  :love-path="uploadOption.lovePath"
                  :file-list="fileList.current"
                  :accept="uploadOption.accept"
                  :show-file-list="uploadOption.showFileList"
                  :tips="uploadOption.tips"
                  @preview="onPreview"
                  @remove="onRemove"
                  @success="onSuccess" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      正文字数统计:{{words}}
      <el-button size="medium" type="info" @click="handleClose">取消</el-button>
      <axj-button color="#00adb5" size="max" @click="handleSubmit">发布</axj-button>
    </div>
  </div>
</template>

<script>
const defaultForm = {
  status: 0,
  level: undefined,
  school_id: undefined,
  academy_id: undefined,
  department_id: undefined,
  subject_id: undefined,
  class_id: undefined,
  subscriber_type: undefined, // 学生类别 0 为本科生...
  subscriber_grade: undefined,
  title: '', // 文章题目
  content: '', // 文章内容
  description: '', // 文章摘要
  user_id: undefined,
  user_name: '',
  user_avatar: '',
  is_comment: 1,
  main_tag_id: undefined,
  thumb: '',
  source_directory: ''
}

import {createSchoolNotices,createSchoolPosterAttachment,getSchoolNotice,updateSchoolNotice,deleteSchoolAttachment} from '@/api/axj-information/axj-information-post'
export default {
  name: "school-post-edit",
  computed:{
    words: function() {
      var length = this.form.content.replace(/<[^>]+>/g, "").length
      this.form.description = this.form.content.replace(/<[^>]+>/g, "").slice(0, 100)
      return length
    }
  },
  methods:{
    handleClose(){
      this.$emit('close')
    },
    handleOpen(){
      let user=this.$store.getters.getUser
      // 初始化一些公用数据
      // this.initData()
      // 创建 sourceDirectory 规则为 [uuid_打开这页面的时间戳]
      this.uploadOption.lovePath.source_directory = user.uid + '_' + Date.parse(new Date()) / 1000
      // 判断编辑状态
      if (!this.isCreate) {
        // 编辑文章，使用route中的id获取form
        // const id = this.$route.params && this.$route.params.id
        // // data 中的 id，记录待使用
        // this.id = parseInt(id)
        // 获取文章数据
        this.handleGetArticleData(this.postId)
      } else {
        // 发布文章 form 为 default form
        this.form = Object.assign({}, defaultForm)
        this.form.school_id = user.schoolId
        // this.schoolInfo.schoolName = this.info.School.name
        this.form.level = 1
      }
    },
    handleGetArticleData(id) {
      this.loading = true
      getSchoolNotice(id)
        .then(res=> {
          const data = res.data
          // 常规数据
          this.form = Object.assign({},defaultForm, data)
          // 状态
          this.status = this.form.status
          // 保存附件信息（若是有附件）
          if(data.Attachments) {
            this.fileList.current = data.Attachments.map(item=> {
              let file = {
                id: item.id,
                name: item.name,
                url: item.url,
                type: item.type,
                status: "success"
              }
              // 若是没有前缀的话
              if(!(file.url.indexOf('http')>=0)) {
                file.url = this.$store.getters.getResourcePrefix.url + file.url
              }
              return file
            })
          }
          // 去掉form中的多余属性
          this.$delete(this.form,'create_time')
          this.$delete(this.form,'update_time')
          this.$delete(this.form,'Attachments')
          this.$delete(this.form,'School')
          this.$delete(this.form,'Academy')
          this.$delete(this.form,'Department')
          this.$delete(this.form,'Major')
          this.$delete(this.form,'Count')
          this.$delete(this.form,'User')
          this.schoolInfo.schoolName = data.School.name ? data.School.name : ""
          this.schoolInfo.academyName = data.Academy.name ? data.Academy.name : ""
          this.schoolInfo.departmentName = data.Department.name ? data.Department.name : ""

          // 若数据库中已经存放了该文章的 source directory
          if (data.source_directory != '') {
            // uploadOption 中也使用该 source directory
            this.uploadOption.lovePath.source_directory = data.source_directory
          }

          this.loading = false
          // 作者信息
          // this.articleAuthor.nickname = data.user_name
          // this.articleAuthor.avatar = this.handleSliceURL(data.user_avatar, false)
          // this.articleAuthor.uid = data.user_id
          // this.form = res
        })
        .catch(err=> {
          this.$notify.error({
            "msg": err
          })
          this.loading = false
        })
    },
    textChangeHandler(delta, oldDelta, source) {
      // console.group('QuillEditor textChangeHandler')
      // console.log(delta, oldDelta, source)
      // console.groupEnd()
    },
    selectionChangeHandler(range, oldRange, source) {
      // console.group('QuillEditor selectionChangeHandler')
      // console.log(range, oldRange, source)
      // console.groupEnd()
    },
    editorChangeHandler(eventName, ...args) {
      // console.group('QuillEditor editorChangeHandler')
      // console.log(eventName, args)
      // console.groupEnd()
    },
    onChangeSchool(value) {
      if(value) {
        this.form.school_id = value.schoolid
        this.schoolInfo.schoolName = value.schoolName
      } else {
        this.form.school_id = this.info.School.id
        this.schoolInfo.schoolName = this.info.School.name
      }
    },
    onChangeSchoolV2(value) {
      console.log("school select", value)
      if(value) {
        this.form.school_id = value.school.id
        this.schoolInfo.schoolName = value.school.name
        this.form.academy_id = value.academy.id
        this.schoolInfo.academyName = value.academy.name
        this.form.department_id = value.department.id
        this.schoolInfo.departmentName = value.department.name
        this.form.level = value.level
      } else {
        this.form.school_id = this.info.School.id
        this.schoolInfo.schoolName = this.info.School.name
        this.form.academy_id = undefined
        this.schoolInfo.academyName = ''
        this.form.department_id = undefined
        this.schoolInfo.departmentName = ''
        this.form.level = 1
      }
      // if(value) {
      //   this.form.school_id = value.schoolid
      //   this.schoolInfo.schoolName = value.schoolName
      // } else {
      //   this.form.school_id = this.info.School.id
      //   this.schoolInfo.schoolName = this.info.School.name
      // }
    },
    onPreview(file) {
      console.log(file)
      console.log(this.fileList.current)
    },
    onRemove(file, fileList) {
      // 若是存在 id
      if(file.id){
        // 记录
        this.fileList.remove.push(file.id)
      }
      this.fileList.current = fileList.map(item => {
        if (typeof(item.response) != 'undefined') {
          return {
            id: item.id,
            uid: item.uid,
            name: item.response.old_name,
            url: item.response.url,
            type: item.type,
            status: item.status
          }
        }
        return item
      })
      console.log(file)
      console.log(fileList)
    },
    onSuccess(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        type: response.type,
        status: "success"
      }
      console.log(file)
      // 更新 fileList
      this.fileList.current[this.fileList.current.length] = file
    },
    handleSubmit(status) {
      // 表单校验
      this.$refs['form'].validate(async (valid) => {
        if(valid) {
          // 补充表单信息
          this.form.status = status
          // uploadOption.lovePath.source_directory 中保存的为文章的 source_directory
          this.form.source_directory = this.uploadOption.lovePath.source_directory
          // fileList中的fileType修改为后台需要的格式
          this.fileList.current = this.fileList.current.map(item=> {
            // 使用函数替换 fileType
            item.type = this.handleResetFileType(item.type)
            return item
          })
          // 判断是否有删除附件
          if(this.fileList.remove.length) {
            // 从数据库中删除记录
            this.deleteAttachment()
          }
          // 创建文章时
          if(this.isCreate) {
            this.form.user_id = this.$store.getters.getUser.infoUserUid
            this.form.user_name = this.$store.getters.getUser.uname
            this.form.user_avatar = this.$store.getters.getUser.avatar
            // 创建文章时使用同步
            this.id = await this.handleCreateArticle(this.form)
            await this.handelCreateAttachment(this.id)
            this.loading = false
            this.$emit("created")
          } else {
            await this.handelCreateAttachment(this.postId)
            await this.handleUpdateArticle(this.form)
            await this.handleUpdateArticleStatus(this.form)
            this.$emit("updated")
          }
        }
      })
    },
    handleCloseSubmit() {
      // 取消修改
      this.$nextTick(()=> {
        this.$router.go(-1)
      })
    },
    handleCreateArticle(form) {
      console.log(form)
      return new Promise((resolve, reject)=> {
        this.loading = true
        createSchoolNotices(form)
          .then(res=> {
            this.$notify({
              title: form.status == 0 ? '保存成功!' : '发布成功!',
              type: 'success',
              duration: 2000
            })
            resolve(res.data.id)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleUpdateArticle(form) {
      return new Promise((resolve, reject)=> {
        // 修改文章内容
        this.loading = true
        updateSchoolNotice(form)
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleUpdateArticleStatus(form) {
      return new Promise((resolve, reject)=> {
        updateSchoolNotice({
          id: form.id,
          where: JSON.stringify({
            thumb_sum: form.thumb_sum,
            cover_type: form.cover_type,
            school_id: form.school_id,
            department_id: form.department_id,
            subject_id: form.subject_id,
            class_id: form.class_id,
            subscriber_type: form.subscriber_type,
            subscriber_grade: form.subscriber_grade,
            status: form.status,
            is_comment: form.is_comment,
            main_tag_id: form.main_tag_id
          })
        })
          .then(res=> {
            this.loading = false
            this.$notify({
              title: '保存成功!',
              type: 'success',
              duration: 2000
            })
            resolve(res)
          })
          .catch(err=> {
            this.loading = false
            this.$notify({
              message: '保存失败，请重试!',
              type: 'error',
              duration: 2000
            })
            reject(err)
          })
      })
    },
    handelCreateAttachment(id) {
      return new Promise((resolve, reject)=> {
        for(var i=0; i<this.fileList.current.length; i++) {
          const fileInfo = this.fileList.current[i]
          const file = {
            schoolnotice_id: id,
            user_id :this.$store.getters.getUser.infoUserUid,
            user_name : this.$store.getters.getUser.uname,
            user_avatar : this.$store.getters.getUser.avatar,
            name: fileInfo.name,
            type: fileInfo.type,
            url: fileInfo.url.slice(this.$store.getters.getResourcePrefix.url.length)
          }
          this.createAttachment(file)
        }
        // 此时并没有完全上传成功
        if(this.fileList.current.length) {
          this.$notify({
            title: '附件上传完成',
            type: 'success',
            duration: 2000
          })
        }
        resolve()
      })
    },
    deleteAttachment() {
      for(var i=0; i<this.fileList.remove.length; i++) {
        deleteSchoolAttachment(this.fileList.remove[i])
          .then(_=> {})
          .catch(_=> {})
      }
    },
    createAttachment(file) {
      createSchoolPosterAttachment(file)
        .then(_=> {})
        .catch(_=> {})
    },
    handleResetFileType(type) {
      let re_type = undefined
      switch (type) {
        case 'application/x-zip-compressed':
          re_type = 'zip';
          break;
        case 'application/octet-stream':
          re_type = 'rar';
          break;
        case 'application/pdf':
          re_type = 'pdf';
          break;
        case 'image/jpeg':
          re_type = 'image';
          break;
        case 'image/png':
          re_type = 'image';
          break;
        case 'image/jpg':
          re_type = 'image';
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          re_type = 'excel';
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          re_type = 'word';
          break;
        case 'application/msword':
          re_type = 'word';
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          re_type = 'ppt';
          break;
        case 'application/vnd.ms-powerpoint':
          re_type = 'ppt';
          break;
        default:
          return type;
      }
      return re_type
    }
  },
  data(){
    return{

      id: undefined,
      form: Object.assign({}, defaultForm),
      allowComments: false,
      // 封面类型
      thumbType: '图片',
      // 通知学校
      schoolInfo: {
        schoolName: '',
        academyName: '',
        departmentName: ''
      },
      // love element upload 上传文件组件参数
      uploadOption: {
        listType: "text",
        drag: true,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/x-zip-compressed","application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation","application/msword"],
        disabled: false,
        limit: 9,
        lovePath:{
          module: "info/poster/schoolnotice",
          source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        allowSize: 10,
        accept: '*',
        tips: "仅允许上传图片、PDF、DOC、EXCEL、PPT、ZIP等文档类型。",
        showFileList: true
      },
      // fileList
      fileList: {
        // remove 存放 remove 事件中的附件id
        remove: [],
        // 当前操作的 fileList
        current: [],
      },
      // web view preview
      webPreview: false,
      // loading
      loading: false,
      // status
      status: 0,
      // 数据验证
      rules: {
        title: [
          { required: true, message: '文章标题不能为空！', trigger: 'change' }
        ],
        content: [
          { required: true, message: '文章正文不能为空！', trigger: 'change' }
        ],
        school_id: [
          { required: true, message: '学校不能为空！', trigger: 'change' }
        ],
      }
    }
  },
  props: {
    isCreate: {
      type: Boolean,
      default: false
    },
    postId:{
      type:Number,
      default:undefined
    }
  },
  watch:{

  }
}
</script>

<style slot-scope lang="scss">
.school-post-edit{
  .dialog-footer{
    margin-top: -10px;
  }
  .axj-post-school-create{
    width: 100%;
    display: inline-block;
    input{
      height: 28px;
      font-size: 12px;
      padding-right: 38px;
    }
    .stu-input-hover{
      font-size: 12px;
      color: #909399;
      right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-post/action/component/school-post-edit.vue